import { render, staticRenderFns } from "./cosOrgIndex.vue?vue&type=template&id=bdd1a6e2&scoped=true"
import script from "./cosOrgIndex.vue?vue&type=script&lang=js"
export * from "./cosOrgIndex.vue?vue&type=script&lang=js"
import style0 from "./cosOrgIndex.vue?vue&type=style&index=0&id=bdd1a6e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdd1a6e2",
  null
  
)

export default component.exports